import { useGate, useStore } from 'effector-react'
import { Gate, getRentalServicesFx } from '~/entities/RentalService/model'
import { Form } from './Form'
import { LoadingBlock } from './LoadingBlock'
import { FormValues } from './model'
import { Title } from './styled'

type ContentProps = {
  onSuccess: (formValues: FormValues) => void
}

export function Content({ onSuccess }: ContentProps) {
  useGate(Gate)

  const rentalServicesPending = useStore(getRentalServicesFx.pending)

  return (
    <div>
      <Title>Дополнительные услуги</Title>

      {rentalServicesPending ? (
        <LoadingBlock />
      ) : (
        <Form onSuccess={onSuccess} />
      )}
    </div>
  )
}
